module.exports = __webpack_public_path__ + "static/img/fkzt2.6167911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/fkzt2.png
// module id = 319
// module chunks = 0